export enum LastScreenEnum {
  ConfirmationSuccess = 'CONFIRMATION_SUCCESS',
  ContractOwnerDetails = 'CONTRACT_OWNER_DETAILS',
  ContractVehicleDetails = 'CONTRACT_VEHICLE_DETAILS',
  Driver = 'DRIVER',
  OffersRanking = 'OFFERS_RANKING',
  PaymentSelection = 'PAYMENT_SELECTION',
  Start = 'START',
  Upsale = 'UPSALE',
  Usage = 'USAGE',
  Vehicle = 'VEHICLE',
}
